import React from "react";

const Button = ({ className: styledClassName, url = "#", label = "", ...rest }) => {
    return <a className={`${styledClassName}`} href={url} {...rest}>
        {label}
        </a>
};

export default Button;